export default {
  authVerifyAlert: 'auth-verify-alert',
};




// WEBPACK FOOTER //
// ./src/event-bus/event.js